/*
	AUTHOR : SOHAN
    USE : To Show item inventory details
    DATE : 06 MAY 2019

*/

// @module ProductDetails
define(
	'ProductDetails.Inventory.Information.View'
,	[
		'LiveOrder.Model'

	,	'product_details_inventory_information.tpl'

	,	'Backbone'
	]
,	function (
		LiveOrderModel

	,	product_details_inventory_information_tpl

	,	Backbone
	)
{
	'use strict';

	// @class ProductDetails.Inventory.Information.View @extends Backbone.View
	return Backbone.View.extend({

			template: product_details_inventory_information_tpl

			//@method getContext
			//@return {ProductDetails.Inventory.Information.View.Context}
		,	getContext: function getContext ()
			{
				var qtyonOrder = 0;
				var qtyOnOrderArr = this.model.get('item').get('quantityonorder_detail').locations;
				for(var q=0; q < qtyOnOrderArr.length; q++)
				{
					if(qtyOnOrderArr[q].internalid == 9)//Pearlgreen Inventory location
					{
						qtyonOrder = qtyOnOrderArr[q].quantityonorder;
					}
				}

				var invDetails = [
					{
						label: 'On Hand'
					,	value: this.model.get('item').get('quantityonhand_detail').quantityonhand != undefined ? this.model.get('item').get('quantityonhand_detail').quantityonhand : '-'
					}
			/*	,	{
						label: 'Confirmed'
					,	value: this.model.get('item').get('confirmed') != undefined ? this.model.get('item').get('confirmed') : '-'
					}
				,	{
						label: 'Actual O/H'
					,	value: this.model.get('item').get('actual') != undefined ? this.model.get('item').get('actual') : '-'
					}
				,	{
						label: 'Unconv. Resv.'
					,	value: this.model.get('item').get('resv') != undefined ? this.model.get('item').get('resv') : '-'
					}
				,	{
						label: 'Commited'
					,	value: this.model.get('item').get('quantitycommitted_detail').quantitycommitted !=undefined ? this.model.get('item').get('quantitycommitted_detail').quantitycommitted : '-'
					}*/
				,	{
						label: 'Avail to Sell'
					,	value: this.model.get('item').get('quantityavailable_detail').quantityavailable != undefined ? this.model.get('item').get('quantityavailable_detail').quantityavailable : '-'
					}
				,	{
						label: 'On Order'
					,	value: qtyonOrder//this.model.get('item').get('quantityonorder_detail').quantityonorder != undefined ? this.model.get('item').get('quantityonorder_detail').quantityonorder : '-'
					}
				];

				//@class ProductDetails.Inventory.Information.View.Context
				return {
					//@property {Product.Model} model
					model: this.model

				,	invDetails: invDetails
				};
				//@class ProductDetails.Inventory.Information.View
			}
		});
});

